<template>
  <div class="ui-input">
    <label v-if="!hide_label" class="ui-label" :for="name">
      {{ label }}
      <span v-if="required && label" class="ui-required">*</span>
    </label>
    <input class="ui-input-field" :class="{ 'ui-input--error': error }" :value="modelValue" @input="updateValue"
      :type="type" :name="name" :placeholder="placeholder" :min="type === 'number' ? min : null"
      :max="type === 'number' ? max : null" :minlength="type === 'text' ? minlength : null"
      :maxlength="type === 'text' ? maxlength : null" @blur="onBlur" />
    <div class="ui-hint">
      {{ hint }}
      <slot name="hint"></slot>
      <div v-if="error || (Array.isArray(errorMessages) && errorMessages.length)" class="text-error ui-hint mt-1 ml-1">
        <div v-for="(msg, i) in normalizedMessages" :key="i">{{ msg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UiInput",
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    hide_label: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [Number, String],
      default: null,
    },
    max: {
      type: [Number, String],
      default: null,
    },
    minlength: {
      type: [Number, String],
      default: null,
    },
    maxlength: {
      type: [Number, String],
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
  },
  computed: {
    normalizedMessages() {
      if (typeof this.errorMessages === "string") {
        return [this.errorMessages];
      }
      return Array.isArray(this.errorMessages) ? this.errorMessages : [];
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value); // Emit update:modelValue in plaats van input
    },
    onBlur(event) {
      this.$emit("blur", event); // Emit naar parent zodat die kan valideren
    },
  },
};
</script>
